export const HEADING =
  'You currently have {{num}} leads to take action on. Click the link below or navigate to your leads tab';
